var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clipboard"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M37.26 14.3003C37.34 15.5203 37.24 16.9003 37 18.4403L35.54 27.8203C34.3 35.6403 30.68 38.2803 22.86 37.0603L13.48 35.5803C10.78 35.1603 8.69998 34.4403 7.17998 33.3603C4.27998 31.3403 3.43998 28.0203 4.23998 22.9003L5.71998 13.5203C6.95998 5.70028 10.58 3.06028 18.4 4.28028L27.78 5.76028C34.06 6.74028 37 9.30028 37.26 14.3003Z",
    stroke: "var(--stroke-0, #004192)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.4,
    d: "M40.9999 26.9398L37.9999 35.9598C35.4999 43.4798 31.4999 45.4798 23.9799 42.9798L14.9599 39.9798C10.4199 38.4798 7.89993 36.3998 7.17993 33.3598C8.69993 34.4398 10.7799 35.1598 13.4799 35.5798L22.8599 37.0598C30.6799 38.2798 34.2999 35.6398 35.5399 27.8198L36.9999 18.4398C37.2399 16.8998 37.3399 15.5198 37.2599 14.2998C42.0399 16.8398 43.0799 20.6798 40.9999 26.9398Z",
    stroke: "var(--stroke-0, #004192)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.4,
    d: "M16.48 17.96C18.402 17.96 19.96 16.402 19.96 14.48C19.96 12.558 18.402 11 16.48 11C14.558 11 13 12.558 13 14.48C13 16.402 14.558 17.96 16.48 17.96Z",
    stroke: "var(--stroke-0, #004192)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_4",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClipboard);
export default __webpack_public_path__ + "static/media/icon-clipboard.3e4e7ca068813b7dc7ddaf9c9516649e.svg";
export { ForwardRef as ReactComponent };